"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelRatiosT = exports.ModelRatios = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Settings for the skeletal model that are ratios.
 * These values range from 0 to 1.
 */
class ModelRatios {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsModelRatios(bb, obj) {
        return (obj || new ModelRatios()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsModelRatios(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ModelRatios()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    imputeWaistFromChestHip() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    imputeWaistFromChestLegs() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    imputeHipFromChestLegs() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    imputeHipFromWaistLegs() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    /**
     * Hip's yaw and roll is set to the average of legs when 1.0
     */
    interpHipLegs() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    /**
     * Knee trackers' yaw and roll is set to the lower leg's when 1.0
     */
    interpKneeTrackerAnkle() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    /**
     * Upper leg's yaw and roll is set to the lower leg's when 1.0
     */
    interpKneeAnkle() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    static startModelRatios(builder) {
        builder.startObject(7);
    }
    static addImputeWaistFromChestHip(builder, imputeWaistFromChestHip) {
        builder.addFieldFloat32(0, imputeWaistFromChestHip, 0);
    }
    static addImputeWaistFromChestLegs(builder, imputeWaistFromChestLegs) {
        builder.addFieldFloat32(1, imputeWaistFromChestLegs, 0);
    }
    static addImputeHipFromChestLegs(builder, imputeHipFromChestLegs) {
        builder.addFieldFloat32(2, imputeHipFromChestLegs, 0);
    }
    static addImputeHipFromWaistLegs(builder, imputeHipFromWaistLegs) {
        builder.addFieldFloat32(3, imputeHipFromWaistLegs, 0);
    }
    static addInterpHipLegs(builder, interpHipLegs) {
        builder.addFieldFloat32(4, interpHipLegs, 0);
    }
    static addInterpKneeTrackerAnkle(builder, interpKneeTrackerAnkle) {
        builder.addFieldFloat32(5, interpKneeTrackerAnkle, 0);
    }
    static addInterpKneeAnkle(builder, interpKneeAnkle) {
        builder.addFieldFloat32(6, interpKneeAnkle, 0);
    }
    static endModelRatios(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createModelRatios(builder, imputeWaistFromChestHip, imputeWaistFromChestLegs, imputeHipFromChestLegs, imputeHipFromWaistLegs, interpHipLegs, interpKneeTrackerAnkle, interpKneeAnkle) {
        ModelRatios.startModelRatios(builder);
        if (imputeWaistFromChestHip !== null)
            ModelRatios.addImputeWaistFromChestHip(builder, imputeWaistFromChestHip);
        if (imputeWaistFromChestLegs !== null)
            ModelRatios.addImputeWaistFromChestLegs(builder, imputeWaistFromChestLegs);
        if (imputeHipFromChestLegs !== null)
            ModelRatios.addImputeHipFromChestLegs(builder, imputeHipFromChestLegs);
        if (imputeHipFromWaistLegs !== null)
            ModelRatios.addImputeHipFromWaistLegs(builder, imputeHipFromWaistLegs);
        if (interpHipLegs !== null)
            ModelRatios.addInterpHipLegs(builder, interpHipLegs);
        if (interpKneeTrackerAnkle !== null)
            ModelRatios.addInterpKneeTrackerAnkle(builder, interpKneeTrackerAnkle);
        if (interpKneeAnkle !== null)
            ModelRatios.addInterpKneeAnkle(builder, interpKneeAnkle);
        return ModelRatios.endModelRatios(builder);
    }
    unpack() {
        return new ModelRatiosT(this.imputeWaistFromChestHip(), this.imputeWaistFromChestLegs(), this.imputeHipFromChestLegs(), this.imputeHipFromWaistLegs(), this.interpHipLegs(), this.interpKneeTrackerAnkle(), this.interpKneeAnkle());
    }
    unpackTo(_o) {
        _o.imputeWaistFromChestHip = this.imputeWaistFromChestHip();
        _o.imputeWaistFromChestLegs = this.imputeWaistFromChestLegs();
        _o.imputeHipFromChestLegs = this.imputeHipFromChestLegs();
        _o.imputeHipFromWaistLegs = this.imputeHipFromWaistLegs();
        _o.interpHipLegs = this.interpHipLegs();
        _o.interpKneeTrackerAnkle = this.interpKneeTrackerAnkle();
        _o.interpKneeAnkle = this.interpKneeAnkle();
    }
}
exports.ModelRatios = ModelRatios;
class ModelRatiosT {
    constructor(imputeWaistFromChestHip = null, imputeWaistFromChestLegs = null, imputeHipFromChestLegs = null, imputeHipFromWaistLegs = null, interpHipLegs = null, interpKneeTrackerAnkle = null, interpKneeAnkle = null) {
        this.imputeWaistFromChestHip = imputeWaistFromChestHip;
        this.imputeWaistFromChestLegs = imputeWaistFromChestLegs;
        this.imputeHipFromChestLegs = imputeHipFromChestLegs;
        this.imputeHipFromWaistLegs = imputeHipFromWaistLegs;
        this.interpHipLegs = interpHipLegs;
        this.interpKneeTrackerAnkle = interpKneeTrackerAnkle;
        this.interpKneeAnkle = interpKneeAnkle;
    }
    pack(builder) {
        return ModelRatios.createModelRatios(builder, this.imputeWaistFromChestHip, this.imputeWaistFromChestLegs, this.imputeHipFromChestLegs, this.imputeHipFromWaistLegs, this.interpHipLegs, this.interpKneeTrackerAnkle, this.interpKneeAnkle);
    }
}
exports.ModelRatiosT = ModelRatiosT;
